var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherWindDirection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M16.862 5.864 23.29 25.15a.9.9 0 0 1-.392 1.055.9.9 0 0 1-1.115-.13l-5.785-5.786-5.785 5.785a.9.9 0 0 1-1.115.13.91.91 0 0 1-.392-1.054l6.428-19.285a.84.84 0 0 1 .221-.361.85.85 0 0 1 .643-.262.88.88 0 0 1 .864.623z"
})));
export default SvgWeatherWindDirection;